var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14645 5.64645C2.34171 5.45118 2.65829 5.45118 2.85355 5.64645L8.5 11.2929L14.1464 5.64645C14.3417 5.45118 14.6583 5.45118 14.8536 5.64645C15.0488 5.84171 15.0488 6.15829 14.8536 6.35355L8.85355 12.3536C8.65829 12.5488 8.34171 12.5488 8.14645 12.3536L2.14645 6.35355C1.95118 6.15829 1.95118 5.84171 2.14645 5.64645Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.3cac7e2659bcd8e888f1695ea9005a40.svg";
export { ForwardRef as ReactComponent };